import { z } from "zod";

/** Matches `InsuranceCategoryEnum` (excluding `Ine = 0`). */
export enum InsuranceCategoryEnum {
    PROPERTY_INSURANCE = 1,
    VEHICLE_INSURANCE = 2,
    LIFE_INSURANCE = 3,
    TRAVEL_INSURANCE = 4,
}

export const InsuranceCategoryEnumSchema = z.nativeEnum(InsuranceCategoryEnum);
